import { AllDayPanel } from '@devexpress/dx-react-scheduler-material-ui';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()({
  alldayCellComponent: {
    height: 60,
  },
});

export const AllDayCellComponent = (props: AllDayPanel.CellProps) => {
  const { classes } = useStyles();
  return (
    <AllDayPanel.Cell
      className={classes.alldayCellComponent}
      {...props}
    ></AllDayPanel.Cell>
  );
};
